import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import BoxContainer from '../../style-components/BoxContainer.jsx';
import CoursesTable from '../../style-components/Tables/CoursesTable.jsx';
import { getCurrentUser } from '../../models/user.js';

const CourseListAll = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser()
      .then(user => {
        if (user.role !== 'TEACHER' && user.role !== 'ADMIN') {
          navigate('/unauthorized');
        }
      })
      .catch();
  }, []);

  return (
    <BoxContainer>
      <CoursesTable />
    </BoxContainer>
  );
};

export default CourseListAll;
